import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { useRoutes } from "@/components/fastshift/src/common/hooks";
import {
    FASTSHIFT_PATH_KEYS,
    FASTSHIFT_PATHS
} from "@/components/fastshift/src/common/routes/constants";
import { useFastshiftSelector } from "@/components/fastshift/src/state";
import { FastshiftUserDetailsExpectedError } from "@/components/fastshift/src/state/types";

import { LegalConsentPage } from "../../legal-consent";

import { CriticalErrorDisplay } from "./critical-error-display/critical-error-display";
import { useShouldShowConsentLandingPage } from "./hooks";
import { NotEligibleDisplay } from "./not-eligible-display";

export const FastshiftPage = () => {
    const { paths, getPathByDomainId } = useRoutes();

    const { data: userDetails, error: userDetailsError } = useFastshiftSelector(
        (state) => state.userDetails
    );
    const navigate = useNavigate();
    const isPartnerOrInternal =
        userDetails?.userType === "PARTNER" ||
        userDetails?.userType === "INTERNAL";

    const { data: userHasConsented } = useFastshiftSelector(
        (state) => state.portalUserConsent
    );

    const shouldShowConsentLandingPage = useShouldShowConsentLandingPage();

    useEffect(() => {
        if (userDetails) {
            if (userDetails.userType === "CUSTOMER") {
                // if customer has not consented yet, remain on Home page
                if (!userHasConsented) {
                    return;
                }
                // customer has consented, so redirect to For You Page
                const url = getPathByDomainId(
                    FASTSHIFT_PATHS[FASTSHIFT_PATH_KEYS.OVERVIEW],
                    userDetails.userDomain?.domainId ?? ""
                );
                if (url) {
                    navigate(url);
                }
            } else if (isPartnerOrInternal) {
                const url = paths.selection;
                if (url) {
                    navigate(url);
                }
            }
        }
    }, [
        userDetails,
        isPartnerOrInternal,
        navigate,
        getPathByDomainId,
        paths.selection,
        userHasConsented
    ]);

    if (
        userDetailsError ===
        FastshiftUserDetailsExpectedError.NO_ELIGIBLE_LICENSE
    ) {
        return (
            <div>
                <NotEligibleDisplay ineligibilityReason="no-license" />
            </div>
        );
    }

    if (userDetailsError === FastshiftUserDetailsExpectedError.NO_ACCESS) {
        return (
            <div>
                <NotEligibleDisplay ineligibilityReason="not-linked" />
            </div>
        );
    }

    if (shouldShowConsentLandingPage) {
        return <LegalConsentPage />;
    }

    return <CriticalErrorDisplay />;
};
